export default __webpack_public_path__ + "static/media/circle2.59288cfe.jpg";